import { SelectionGroupOption } from 'common/components';
import { Solution } from '../solution-card';

export const HALLWAY_SOLUTION_TAB_LIST: SelectionGroupOption[] = [
  { value: '1', text: 'Банкетка и шкаф' },
  { value: '2', text: 'Подвесные полки' },
  { value: '3', text: 'Полки и обувной шкаф' },
];

export const HALLWAY_SOLUTION_CONTENT_MAP: Record<string, Solution> = {
  '1': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/4-1.jpg/4-1.jpg',
    imgAlt: 'Банкетка и шкаф',
    title: `Банкетка и шкаф`,
    size: `Шкаф: 72 × 165,6 × 32 см; банкетка: 108 × 42 × 38 см`,
    productIds: [
      '82731882',
      '82731879',
      '82731875',
      '82731878',
      '82020867',
      '82731907',
      '82731904',
      '82731898',
      '82020863',
      '82020864',
      '82036412',
    ],
    '82731882': {
      productCount: 1,
    },
    '82731879': {
      productCount: 1,
    },
    '82731875': {
      productCount: 3,
    },
    '82731878': {
      productCount: 3,
    },
    '82020867': {
      productCount: 3,
    },
    '82731907': {
      productCount: 3,
    },
    '82731904': {
      productCount: 4,
    },
    '82731898': {
      productCount: 1,
    },
    '82020863': {
      productCount: 1,
    },
    '82020864': {
      productCount: 1,
    },
    '82036412': {
      productCount: 11,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-prikhozhaya-banketka-i-shkaf',
  },
  '2': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/4-2.jpg/4-2.jpg',
    imgAlt: 'Подвесные полки',
    title: `Подвесные полки`,
    size: `216 × 140 × 32 см`,
    productIds: ['82731871', '82731870', '82731915', '82731903', '82036412'],
    '82731871': {
      productCount: 2,
    },
    '82731870': {
      productCount: 1,
    },
    '82731915': {
      productCount: 2,
    },
    '82731903': {
      productCount: 3,
    },
    '82036412': {
      productCount: 5,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-prikhozhaya-podvesnyye-polki',
  },
  '3': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/4-3.jpg/4-3.jpg',
    imgAlt: 'Полки и обувной шкаф',
    title: `Полки и обувной шкаф`,
    size: `Шкаф: 144 × 72 × 32 см; полки: 108 × 72 × 36 см`,
    productIds: ['82731911', '82731908', '82731910', '82020865', '82731902', '82731905', '82036412'],
    '82731911': {
      productCount: 3,
    },
    '82731908': {
      productCount: 5,
    },
    '82731910': {
      productCount: 2,
    },
    '82020865': {
      productCount: 1,
    },
    '82731902': {
      productCount: 5,
    },
    '82731905': {
      productCount: 2,
    },
    '82036412': {
      productCount: 10,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-prikhozhaya-polki-i-obuvnoy-shkaf',
  },
};
